import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  /**
   * Sorts an array by a given field in a specific order.
   *
   * If the field value is not in the order array, it will be placed at the end.
   *
   * @example
   * const array = [
   *   { id: 1, name: 'John' },
   *   { id: 2, name: 'Alice' },
   *   { id: 3, name: 'Bob' },
   * ];
   * const order = ['John', 'Bob'];
   * const result = orderByPipe.transform(array, 'name', order);
   * // result is [{ id: 1, name: 'John' }, { id: 3, name: 'Bob' }, { id: 2, name: 'Alice' }]
   * @param array the array to sort
   * @param field the field to sort by
   * @param order the order array
   * @returns the sorted array
   */
  transform(array: any | undefined[], field: string, order: any[] | null): any[] {
    if (!Array.isArray(array)) {
      return array;
    }
    array.sort((a, b) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    if (order === null || order.length === 0) {
      return array;
    }
    array.sort((a, b) => {
      const indexA = order.indexOf(a[field]);
      const indexB = order.indexOf(b[field]);

      // If a[field] is not in order, it will be placed at the end
      if (indexA === -1) {
        return 1;
      }
      // If b[field] is not in order, it will be placed at the end
      if (indexB === -1) {
        return -1;
      }

      // If both are in order, sort them based on their position in order array
      return indexA - indexB;
    });

    return array;
  }
}
